/**
 * Готовит редактируемые исходные данные отдельной версии ПЛАНа.
 * Используется UI ПЛАНа и payload пересчёта; утилита не знает о store, API и
 * способе отображения полей.
 */
function comparableNumber(value) {
  if (value === null || value === undefined || String(value).trim() === "") return null;
  const normalized = String(value).replace(/\s/g, "").replace(",", ".");
  const number = Number(normalized);
  return Number.isFinite(number) ? number : null;
}

// Возвращает все редактируемые value-параметры вместе с их источником.
export function buildPlanParameterRows(calculation) {
  const variables = calculation?.variables || {};
  const overrides = calculation?.input_overrides || {};

  return (calculation?.preset_snapshot?.params || [])
    // Формулы рассчитывает backend. Исходные числа разрешено переопределить
    // для одной версии ПЛАНа независимо от того, пришли они из заказа или пресета.
    .filter((parameter) => parameter.param_type === "value")
    .map((parameter) => {
      const override = overrides[parameter.code];
      return {
        code: parameter.code,
        name: parameter.name,
        unit: parameter.unit || "",
        source: parameter.source || null,
        value: variables[parameter.code] ?? null,
        originalValue: override?.original_value ?? variables[parameter.code] ?? null,
        overridden: Boolean(override),
      };
    });
}

// Возвращает только отличающиеся валидные значения для нового расчёта ПЛАНа.
export function buildPresetParamsPayload(rows, draft) {
  return rows.flatMap((row) => {
    const value = draft[row.code];
    const current = comparableNumber(value);
    const original = comparableNumber(row.originalValue);
    if (current === null || current === original) return [];

    return [{ code: row.code, overridden_value: String(value).trim() }];
  });
}

// Создаёт независимый черновик значений, не изменяя snapshot расчёта.
export function buildParameterDraft(rows) {
  return rows.reduce((draft, row) => {
    draft[row.code] = row.value == null ? "" : String(row.value);
    return draft;
  }, {});
}

// Проверяет, что каждое редактируемое значение можно передать как число.
export function hasInvalidParameterDraft(rows, draft) {
  return rows.some((row) => comparableNumber(draft[row.code]) === null);
}

// Сравнивает значение заказа со значением калькулятора с учётом формата ввода.
export function isPlanParameterDifferent(value, originalValue) {
  const current = comparableNumber(value);
  const original = comparableNumber(originalValue);
  if (current !== null && original !== null) return current !== original;

  return String(value ?? "").trim() !== String(originalValue ?? "").trim();
}

// Повторяет ручные значения версии на актуальном состоянии выбранного калькулятора
export function buildCalculationRepeatPayload(calculation) {
  return {
    presetId: calculation?.calculator_preset_id || null,
    presetParams: Object.entries(calculation?.input_overrides || {}).map(
      ([code, override]) => ({
        code,
        overridden_value: override.overridden_value,
      })
    ),
  };
}
